export default {
  id: null,
  cc: null,
  to: "",
  bcc: null,
  subject: "",
  body: "",
  sendMeCopy: false,
};
